<template>
  <b-container fluid id="events" class="page">
    <div>
      <h1>Events</h1>
      <div class="search-section d-flex justify-content-start align-items-center flex-wrap">
        <b-form-input v-model="current_search" class="search-bar" placeholder="Search by event title or location">
        </b-form-input>
        <b-form-select
        id="year_dropdown"
        v-model="selectedYear"
        :options="availableYears"
        class="dropdown-publications-years"
      ></b-form-select>
      </div>
    </div>

    <div v-if="filteredEvents.length !== 0">
      <div v-for="event in filteredEvents" :key="event.id">
        <event :event_data="event"></event>
      </div>
    </div>
    <div v-else id="no-data" class="d-flex">
      <span><font-awesome icon="exclamation" fixed-width /></span>
      <p>No events have been added yet!</p>
    </div>
  </b-container>
</template>

<script>
import Event from "@/components/Event.vue";

export default {
  name: "Events",
  components: {
    Event
  },
  created() {
    this.events = this.page.get_events
      .filter(
        function (event) {
          return event.vcmi === true;
        }.bind(this)
      )
      .sort((e1, e2) => {
        const d1 = Date.parse(e1.date_end);
        const d2 = Date.parse(e2.date_end);

        if (d1 > d2) {
          return -1;
        }

        if (d1 < d2) {
          return 1;
        }

        return 0;
      });
  },
  data() {
    return {
      pages: null,
      events: [],
      current_search: '',
      selectedYear: '',
    };
  },
  methods: {
  },
  computed: {
    availableYears() {
      const years = this.events.map(event => new Date(event.date_begin).getFullYear());
      const uniqueYears = [...new Set(years)].sort((a, b) => b - a);

      const yearList = uniqueYears.map(year => ({ value: String(year), text: String(year) }));

      return [{ value: '', text: 'All Years' }, ...yearList];
    },
    filteredEvents() {
      const query = this.current_search.toLowerCase();
      return this.events.filter(event => {
        const matchesSearch =
          event.title.toLowerCase().includes(query) ||
          event.location.toLowerCase().includes(query);

        const eventYear = new Date(event.date_begin).getFullYear().toString();
        const matchesYear = !this.selectedYear || this.selectedYear === eventYear;

        return matchesSearch && matchesYear;
      });
    }
  },
  props: ["page"]
};
</script>

<style lang="scss">
.search-section {
  display: flex;
  flex-direction: row;
  gap: 1%;
  margin: 0%;
  margin-top: 1%;
  margin-bottom: 1%;

  align-items: center !important;
  justify-items: center !important;

  * {
    align-self: center !important;
    margin: 0%;

    @include media-breakpoint-down(sm) {
      margin-top: 1%;
    }
  }

  @include media-breakpoint-down(xs) {
    margin-top: 3%;

    flex-direction: column;

    h5 {
      margin-right: auto;
      margin-bottom: 1%;
    }

    .dropdown-publications-years {
      width: 85% !important;
    }
  }
}

.search-bar {
  width: 70%;
  min-width: 17em !important;

  @include media-breakpoint-down(xs) {
    width: 100%;
  }
}

#year_dropdown {
  min-width: min-content;
}
</style>
